export default __webpack_public_path__ + "static/media/icons-notification.a94283c2.svg";